// SafeHeir — service d'alertes email via Brevo (K05/K10/K31)
// Appelle la Supabase Edge Function send-email — clé API Brevo jamais côté client.
// Le prénom du titulaire est lu côté serveur pour les trois types (C3, K120) :
// aucun nom du titulaire n'est envoyé par le client.

import { supabase } from './supabaseClient';

const invoke = (type, payload) =>
  supabase.functions.invoke('send-email', { body: { type, payload } });

export const sendCheckinAlert = async (beneficiaries, config) => {
  if (!beneficiaries || beneficiaries.length === 0) {
    console.warn('[SafeHeir] Aucun bénéficiaire configuré — alerte non envoyée');
    return 0;
  }

  const overdueSince = config.next_check_in_due
    ? new Date(config.next_check_in_due).toLocaleDateString('fr-FR', {
        day: 'numeric', month: 'long', year: 'numeric',
      })
    : 'une date inconnue';

  const results = await Promise.all(
    beneficiaries.map(async (b) => {
      const { error } = await invoke('checkin_alert', {
        beneficiary_name:   b.name,
        to_email:           b.email,
        overdue_since:      overdueSince,
        message_personnel:  b.message || '',
      });
      if (error) { console.error('[SafeHeir] send-email alert échec pour un bénéficiaire', error); }
      return !error;
    })
  );

  return results.filter(Boolean).length;
};

export const sendBeneficiaryNotification = async (beneficiary, token, appUrl) => {
  const { error } = await invoke('beneficiary_notification', {
    recipient_name:     beneficiary.name,
    to_email:           beneficiary.email,
    confirmation_token: token  || undefined,
    app_url:            appUrl || undefined,
  });
  if (error) {
    console.error('[SafeHeir] send-email notification échec', error);
    return false;
  }
  return true;
};

/**
 * Prévient le contact de confiance d'un bénéficiaire (PF-03 CP3.2, D5).
 * Le prénom du titulaire est lu côté serveur (C3) ; l'horodatage de
 * notification est posé côté serveur après envoi réussi (C1).
 * @param {string} beneficiaryId
 * @param {{ name: string, email: string }} contact
 * @returns {Promise<boolean>}
 */
export const sendTrustedContactNotification = async (beneficiaryId, contact) => {
  const { error } = await invoke('trusted_contact_notification', {
    beneficiary_id: beneficiaryId,
    to_email:       contact.email,
    recipient_name: contact.name,
  });
  if (error) {
    console.error('[SafeHeir] send-email contact de confiance échec', error);
    return false;
  }
  return true;
};
